
import Vue from 'vue'

export default ({ invoiceId, isAuthorized = false }) =>
  Vue.$http.put(`taxreceipt/invoicereceipt/${invoiceId}/authorization/`, {
    is_authorized: isAuthorized
  }).then(response => response.data)


// WEBPACK FOOTER //
// ./src/services/taxReceipt/validateStampedInvoice.js